import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import axios from "axios";
import { ThemeContext } from '../context/ThemeContext';
import '../index.css';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/vehicles`)
      .then((res) => res.json())
      .then((data) => setVehicles(data))
      .catch((err) => console.error("Error fetching vehicles:", err));
  }, []);

  const [formData, setFormData] = useState({
    serviceType: "",
    pickupDate: "",
    pickupTime: "",
    pickupLocation: "",
    dropoffLocation: "",
    passengers: 1,
    luggage: 0,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    selectedVehicle: "",
    selectedRent: 0,
    selectedImage: "",
    selectedMileage: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const ReciptSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND}/api/send-receipt`, formData);
      alert("Booking confirmed! A receipt has been sent to your email.");
    } catch (error) {
      console.error("Error submitting form", error);
      alert("Failed to send email.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND}/api/auth/login`, { email, password });

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userId", response.data.userId);
        navigate("/Home");
      } else {
        setError(response.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error. Please try again later.");
    }
  };

  return (
    <div className="vh-92 d-flex flex-column login-page-container">
      <div className="flex-grow-1 d-flex flex-column">
        <div className="d-flex justify-content-center mb-4">
          <h1 className="d-flex justify-content-center align-items-center login-title rounded m-1 p-1">
            <span className="login-title-dark rounded px-2">Tn</span>
            <span className="px-2">Taxi Project</span>
          </h1>
        </div>
        <div className="d-flex justify-content-center mb-3">
          <blockquote className="text-center w-100" style={{fontStyle: 'italic', color: 'var(--highlight)', fontSize: '1.2rem'}}>
            Arrive before you expect to.
          </blockquote>
        </div>

        <div className="d-flex justify-content-end me-5">
          <div className="rounded shadow justify-content-end mb-1 login-card">
            <ul className="nav nav-tabs justify-content-end mx-4 mb-3" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active tab-button"
                  id="login-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#login"
                  type="button"
                  role="tab"
                  aria-controls="login"
                  aria-selected="true"
                >
                  Login
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link tab-button"
                  id="ride-quotation-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#ride-quotation"
                  type="button"
                  role="tab"
                  aria-controls="ride-quotation"
                  aria-selected="false"
                >
                  Get Ride Quotation
                </button>
              </li>
            </ul>
            <div className="tab-content px-4" id="myTabContent">
              {/* Login Tab */}
              <div className="tab-pane fade show active" id="login" role="tabpanel" aria-labelledby="login-tab">
                <h1 className="text-center mb-4">Login</h1>
                {error && <div className="alert alert-danger rounded-3">{error}</div>}
                <form onSubmit={handleSubmit} className="px-2">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label"><strong>Email</strong></label>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      autoComplete="off"
                      className="form-control rounded-3 px-3"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-4 position-relative">
                    <label htmlFor="password" className="form-label">
                      <strong>Password</strong>
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      autoComplete="off"
                      className="form-control rounded-3 px-3"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <i
                      className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        top: "38px",
                        right: "15px",
                        cursor: "pointer",
                        color: "#6c757d",
                      }}
                    ></i>
                  </div>
                  <button type="submit" className="btn btn-dark w-100 rounded-3 py-2">
                    Login
                  </button>
                </form>
                <p className="text-center mt-2">
                  <Link to="/forgot-password" className="forgot-password-link">Forgot Password?</Link>
                </p>
                <p className="text-center mt-2">Don't have an account?</p>
                <p className="btn btn-dark w-100 rounded-3">
                  <Link to="/SignUp" className="register-link">Register</Link>
                </p>
              </div>

              {/* Ride Quotation Tab */}
              <div className="tab-pane fade" id="ride-quotation" role="tabpanel" aria-labelledby="ride-quotation-tab"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingRight: "1rem"
                }}>
                <h2 className="text-center quotation-title mb-4">🚖 Get Ride Quotation</h2>
                <form onSubmit={ReciptSubmit} className="px-2">
                  {/* Personal Info */}
                  <h5 className="section-heading mb-3">Personal Information</h5>
                  <div className="mb-3">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      onChange={handleChange}
                      className="form-control rounded-3 px-3"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      onChange={handleChange}
                      className="form-control rounded-3 px-3"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      className="form-control rounded-3 px-3"
                      required
                    />
                  </div>
                  {/* Ride Details */}
                  <h5 className="section-heading mt-4 mb-3">Ride Details</h5>
                  <div className="mb-3">
                    <label className="form-label">Service Type</label>
                    <select
                      name="serviceType"
                      className="form-select rounded-3 px-3"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="From Airport">From Airport</option>
                      <option value="To Airport">To Airport</option>
                      <option value="Point to Point">Point to Point</option>
                      <option value="Hourly/As Directed">Hourly/As Directed</option>
                    </select>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label className="form-label">Pickup Date</label>
                      <input
                        type="date"
                        name="pickupDate"
                        className="form-control rounded-3 px-3"
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <label className="form-label">Pickup Time</label>
                      <input
                        type="time"
                        name="pickupTime"
                        className="form-control rounded-3 px-3"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Pickup Location</label>
                    <input
                      type="text"
                      name="pickupLocation"
                      className="form-control rounded-3 px-3"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Drop-Off Location</label>
                    <input
                      type="text"
                      name="dropoffLocation"
                      className="form-control rounded-3 px-3"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Passenger Info */}
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label className="form-label">Passengers</label>
                      <input
                        type="number"
                        name="passengers"
                        className="form-control rounded-3 px-3"
                        min="1"
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <label className="form-label">Luggage</label>
                      <input
                        type="number"
                        name="luggage"
                        className="form-control rounded-3 px-3"
                        min="0"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="vehicle-selection">
                    <label>Select Vehicle:</label>
                    <div className="vehicle-list" style={{ display: "grid", gap: "1rem" }}>
                      {vehicles.map((vehicle) => (
                        <div
                          key={vehicle._id}
                          className={`vehicle-card ${formData.selectedVehicle === vehicle._id ? "selected" : ""}`}
                          onClick={() =>
                            setFormData({
                              ...formData,
                              selectedVehicle: vehicle._id,
                              selectedRent: vehicle.rent,
                              selectedImage: `${process.env.REACT_APP_BACKEND}${vehicle.image}`,
                              selectedMileage: vehicle.mileage,
                            })
                          }
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_BACKEND}${vehicle.image}`}
                            alt={vehicle.model}
                            style={{ width: "100px", height: "60px", objectFit: "cover", borderRadius: "6px" }}
                          />
                          <div>
                            <div><strong>{vehicle.model}</strong></div>
                            <div>mileage {vehicle.mileage}</div>
                            <div>Rent Price {vehicle.rent}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-success btn-lg rounded-3 py-2 w-100">
                      Confirm & Book Ride
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer if needed */}
    </div>
  );
}

export default Login;
